import LogoHorizontal from "../components/LogoHorizontal";
import { useTenant } from "../contexts/TenantContext";
import { Button } from "../design/button";
import { Divider } from "../design/divider";
import { Fieldset } from "../design/fieldset";
import { Heading } from "../design/heading";
import { Text } from "../design/text";

const HomePage: React.FC = () => {
  const { tenant } = useTenant();
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-full max-w-lg p-6 text-center bg-white rounded-lg shadow-lg dark:bg-gray-800">
        <div className="items-center w-full my-6 text-center">
          <LogoHorizontal
            tenant={tenant}
            className="items-center h-10 mx-auto"
          />
        </div>
        <Fieldset>
          <Heading className="text-2xl font-semibold text-center">
            Welcome
          </Heading>
          {tenant?.description && (
            <Text style={{ whiteSpace: "pre-line" }}>{tenant.description}</Text>
          )}
          <Divider className="my-6" />
          <div></div>
          <Button href="/register" className="w-full">
            Register
          </Button>
          or
          <Button href="/login" className="w-full">
            Login
          </Button>
        </Fieldset>
      </div>
    </div>
  );
};

export default HomePage;
